
(() => {
  if (window.__renounFreeBindingsUI) return;
  window.__renounFreeBindingsUI = true;

  function update(block) {
    const widget = block.querySelector('.js-exclude-widget');
    const gated = Boolean(widget && widget.classList.contains('tohide'));

    block.classList.toggle('is-gated-variant', gated);

    const chosen = block.querySelector(
      'input[name="binding_choice"]:checked:not(:disabled)'
    );

    const image = block.querySelector('.fb-image');
    const wrap = block.querySelector('.fb-image-wrap');

    if (wrap) wrap.hidden = gated;

    if (
      image &&
      chosen &&
      chosen.value !== 'none' &&
      chosen.dataset.image
    ) {
      if (image.getAttribute('src') !== chosen.dataset.image) {
        image.src = chosen.dataset.image;
      }

      image.alt = `Marker Griffon 13 bindings in ${chosen.dataset.color}`;
    }

    // Countdown
    const timer = block.querySelector('[data-fb-countdown]');
    if (!timer) return;

    const target = Date.parse(timer.dataset.target);
    const remaining = target - Date.now();

    timer.hidden = !Number.isFinite(target) || remaining <= 0;

    if (timer.hidden) return;

    const seconds = Math.floor(remaining / 1000);
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const pad = n => String(n).padStart(2, '0');

    const label = timer.dataset.label || 'OFFER ENDS IN';

    const countdown = `${days}d : ${pad(hours)}h : ${pad(minutes)}m : ${pad(secs)}s`;

    // Preserve styling elements instead of replacing HTML
    let dot = timer.querySelector('.fb-countdown-dot');
    let text = timer.querySelector('.fb-countdown-text');

    if (!dot || !text) {
      timer.textContent = '';

      dot = document.createElement('span');
      dot.className = 'fb-countdown-dot';
      dot.setAttribute('aria-hidden', 'true');

      text = document.createElement('span');
      text.className = 'fb-countdown-text';

      timer.append(dot, text);
    }

    const output = `${label}: ${countdown}`;

    if (text.textContent !== output) {
      text.textContent = output;
    }
  }

  function init() {
    document.querySelectorAll('[data-free-bindings-ui]').forEach(block => {
      if (!block.dataset.fbInitialized) {
        block.dataset.fbInitialized = 'true';

        block.addEventListener('change', () => update(block));

        const widget = block.querySelector('.js-exclude-widget');

        if (widget) {
          new MutationObserver(() => update(block)).observe(widget, {
            attributes: true,
            attributeFilter: ['class']
          });
        }
      }

      update(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  [
    'variant:change',
    'variant:changed',
    'renounpro:gated-variant-change',
    'renounpro:membership-cart-state-change',
    'cart:refresh'
  ].forEach(name => {
    document.addEventListener(name, () => {
      init();
      setTimeout(init, 150);
    });
  });

  setInterval(init, 1000);
})();
